/* Nordic Habit Heart – theme.js */
(function () {
  'use strict';
  var NH = window.NH || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, moneyFormat: '{{amount_no_decimals}} kr', cartType: 'drawer' };

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function formatMoney(cents) {
    var fmt = NH.moneyFormat || '{{amount}} kr';
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = withDelims(value, 0, ' ', ','); break;
      case 'amount_with_comma_separator': out = withDelims(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelims(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = withDelims(value, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = withDelims(value, 0, ' ', ','); break;
      default: out = withDelims(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }
  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------- mobile menu ---------- */
  var menu = $('#MobileMenu');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { if (!menu) return; menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); lockScroll(true); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); lockScroll(false); }); });

  /* ---------- cart drawer ---------- */
  var drawer = $('#CartDrawer');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); lockScroll(true); var p = $('.drawer__panel', drawer); if (p) p.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); lockScroll(false); }
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); if (menu) { menu.classList.remove('is-open'); lockScroll(false); } } });
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (NH.cartType !== 'drawer' || !drawer) return;
      e.preventDefault(); refreshCart().then(openDrawer);
    });
  });

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    $$('[data-cart-count-bubble]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    updateSavings(cart);
    var list = $('[data-cart-items]');
    if (!list) return;
    if (!cart.items.length) { list.innerHTML = '<p class="drawer__empty">Din varukorg är tom.</p>'; return; }
    list.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="72" height="72" loading="lazy">' : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="cline__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      var was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      return '<div class="cline" data-line="' + (i + 1) + '">' +
        '<a class="cline__img" href="' + item.url + '">' + img + '</a>' +
        '<div><a class="cline__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant +
        '<div class="cline__row"><div class="qty"><button type="button" class="qty__btn" data-line-change="-1" aria-label="Minska">−</button>' +
        '<input class="qty__input" type="number" value="' + item.quantity + '" min="0" aria-label="Antal" readonly>' +
        '<button type="button" class="qty__btn" data-line-change="1" aria-label="Öka">+</button></div>' +
        '<button type="button" class="cline__remove" data-line-remove>Ta bort</button></div></div>' +
        '<div class="cline__price">' + formatMoney(item.final_line_price) + was + '</div></div>';
    }).join('');
  }
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(NH.routes.root.replace(/\/$/, '') + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return productCache[handle];
  }
  function updateSavings(cart) {
    var row = $('[data-cart-savings-row]'), out = $('[data-cart-savings]');
    if (!row || !out) return;
    if (!cart.items.length) { row.hidden = true; return; }
    Promise.all(cart.items.map(function (item) {
      return getProduct(item.handle).then(function (p) {
        var compare = 0;
        if (p) { p.variants.forEach(function (v) { if (v.id === item.variant_id && v.compare_at_price > v.price) compare = v.compare_at_price; }); }
        var base = compare > 0 ? compare * item.quantity : item.original_line_price;
        return Math.max(0, base - item.final_line_price);
      });
    })).then(function (vals) {
      var total = vals.reduce(function (a, b) { return a + b; }, 0) + (cart.total_discount && cart.items.every(function(i){return i.total_discount===0;}) ? cart.total_discount : 0);
      if (total > 0) { out.textContent = '−' + formatMoney(total); row.hidden = false; } else { row.hidden = true; }
    });
  }
  function refreshCart() {
    return fetch(NH.routes.root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; })
      .catch(function () {});
  }
  function changeLine(line, qty) {
    return fetch(NH.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line]'); if (!row) return;
      var line = parseInt(row.getAttribute('data-line'), 10);
      var input = $('.qty__input', row); var q = parseInt(input.value, 10) || 0;
      if (e.target.closest('[data-line-change]')) { changeLine(line, Math.max(0, q + parseInt(e.target.closest('[data-line-change]').getAttribute('data-line-change'), 10))); }
      if (e.target.closest('[data-line-remove]')) { changeLine(line, 0); }
    });
    refreshCart();
  }

  /* ---------- product page ---------- */
  $$('[data-pdp]').forEach(function (pdp) {
    var form = $('[data-product-form]', pdp) || $('form[action*="/cart/add"]', pdp);
    var idInput = $('[data-variant-input]', pdp);
    var atc = $('[data-atc]', pdp);
    var atcLabel = $('[data-atc-label]', pdp);
    var atcText = atcLabel ? atcLabel.textContent : '';
    var errorEl = $('[data-form-error]', pdp);
    var stickyPrice = $('[data-sticky-price]', pdp);
    var priceEl = $('[data-price]', pdp);
    var compareEl = $('[data-compare]', pdp);
    var tiers = $$('[data-tier]', pdp);
    var select = $('[data-variant-select]', pdp);

    function setVariant(id, price, compare, available, tierIndex) {
      if (idInput) idInput.value = id;
      if (stickyPrice && price) stickyPrice.textContent = price;
      if (priceEl && price) priceEl.textContent = price;
      $$('[data-atc-price]', pdp).forEach(function (el) { if (price) el.textContent = price; });
      if (compareEl) { compareEl.textContent = compare || ''; compareEl.hidden = !compare; }
      if (atc) { atc.disabled = available === 'false'; if (atcLabel) atcLabel.textContent = available === 'false' ? 'Slutsåld' : atcText; }
      if (typeof tierIndex === 'number') {
        $$('[data-gift]', pdp).forEach(function (g) { g.classList.toggle('is-unlocked', tierIndex + 1 >= parseInt(g.getAttribute('data-unlock'), 10)); });
      }
    }
    tiers.forEach(function (input, idx) {
      input.addEventListener('change', function () {
        tiers.forEach(function (t) { t.closest('.tier').classList.toggle('is-selected', t.checked); });
        setVariant(input.value, input.dataset.price, input.dataset.compare, input.dataset.available, idx);
      });
    });
    var checked = tiers.filter(function (t) { return t.checked; })[0] || tiers.filter(function (t) { return !t.disabled; })[0];
    if (checked) { checked.checked = true; checked.dispatchEvent(new Event('change')); }
    else { $$('[data-gift]', pdp).forEach(function (g) { g.classList.toggle('is-unlocked', parseInt(g.getAttribute('data-unlock'), 10) <= 1); }); }
    if (select) select.addEventListener('change', function () { var o = select.options[select.selectedIndex]; setVariant(o.value, o.dataset.price, o.dataset.compare, o.disabled ? 'false' : 'true'); });

    // qty
    var qInput = $('.qty__input', form || pdp);
    $$('[data-qty-minus]', pdp).forEach(function (b) { b.addEventListener('click', function () { qInput.value = Math.max(1, (parseInt(qInput.value, 10) || 1) - 1); }); });
    $$('[data-qty-plus]', pdp).forEach(function (b) { b.addEventListener('click', function () { qInput.value = (parseInt(qInput.value, 10) || 1) + 1; }); });

    // add to cart
    if (form) {
      form.addEventListener('submit', function (e) {
        if (NH.cartType === 'page') return;
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        atc && atc.setAttribute('aria-busy', 'true');
        if (atc) atc.disabled = true;
        var fd = new FormData(form);
        fetch(NH.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Något gick fel. Försök igen.');
            if (NH.cartType === 'checkout') { window.location.href = '/checkout'; return; }
            return refreshCart().then(openDrawer);
          })
          .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
          .finally(function () { if (atc) { atc.disabled = false; atc.removeAttribute('aria-busy'); } });
      });
    }

    // gallery dots (mobile)
    var track = $('[data-gallery-track]', pdp);
    var dots = $$('.gallery__dot', pdp);
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }

    // sticky ATC
    var sticky = $('[data-sticky-atc]', pdp);
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          var show = !en.isIntersecting && below;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      });
      io.observe(atc);
      var sbtn = $('[data-sticky-btn]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form && form.requestSubmit) form.requestSubmit(); else if (atc) atc.click();
      });
    }
  });

  /* ---------- scroll-to-buy links ---------- */
  $$('[data-scroll-to-buy]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href') || '';
      if (href && href !== '#MainContent' && href.charAt(0) !== '#') return;
      var target = $('[data-tiers]') || $('[data-pdp] .pdp__info') || $(href);
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  /* ---------- sliders ---------- */
  $$('[data-slider]').forEach(function (sl) {
    var track = $('[data-slider-track]', sl);
    var dots = $$('.slider__dot', sl);
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    function step() { return cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function update() {
      var i = Math.round(track.scrollLeft / step());
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    if (!track) return;
    track.addEventListener('scroll', update, { passive: true });
    var prev = $('[data-slider-prev]', sl), next = $('[data-slider-next]', sl);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- delivery estimate (Swedish time) ---------- */
  $$('[data-delivery]').forEach(function (el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
    var minD = parseInt(el.getAttribute('data-min'), 10) || 2;
    var maxD = parseInt(el.getAttribute('data-max'), 10) || 4;
    var out = $('[data-delivery-text]', el);
    var days = ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'];
    var months = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    function seNow() {
      try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' })); } catch (e) { return new Date(); }
    }
    function addBusinessDays(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
    function fmt(d) { return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]; }
    function tick() {
      var now = seNow();
      var ship = new Date(now);
      var isWeekend = now.getDay() === 0 || now.getDay() === 6;
      var dl = new Date(now); dl.setHours(cutoff, 0, 0, 0);
      var countdown = '';
      if (!isWeekend && now < dl) {
        var ms = dl - now; var h = Math.floor(ms / 36e5); var m = Math.floor((ms % 36e5) / 6e4);
        countdown = 'Beställ inom <b>' + h + 'h ' + m + 'm</b> & ';
      } else {
        ship = addBusinessDays(now, 0);
      }
      var base = (!isWeekend && now < dl) ? now : addBusinessDays(now, 1);
      var from = addBusinessDays(base, minD), to = addBusinessDays(base, maxD);
      out.innerHTML = countdown + 'få den <b>' + fmt(from) + ' – ' + fmt(to) + '</b>';
    }
    if (out) { tick(); setInterval(tick, 60000); }
  });

  /* ---------- back to top ---------- */
  var toTop = $('[data-to-top]');
  if (toTop) {
    window.addEventListener('scroll', function () { toTop.classList.toggle('is-visible', window.pageYOffset > 900); }, { passive: true });
    toTop.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
})();
